import { render, staticRenderFns } from "./EZUIKitPlayer.vue?vue&type=template&id=3f95ecac"
import script from "./EZUIKitPlayer.vue?vue&type=script&lang=js"
export * from "./EZUIKitPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports